import React, { Component } from "react";
import Form from "../common/form/form";
import Joi from "joi-browser";
import { connect } from "react-redux";
import Moment from 'moment';
import { loadAllPatient, updatePatient, getProduct, mobileAvailability, emailAvailability } from "../../store/patient";
import {
  mobileInvalid,
  mobileRequired,
  accountNotExist,
  dobRequired,
  dobInvalid,
  informationSaved,
  failed
} from "../common/misc";
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";
import Select from 'react-select'
import { State, City, Country } from 'country-state-city'
import Select2 from "../common/form/select";
const initialState = {
  data: {
    first_name: "",
    last_name: "",
    mobile: "",
    date_of_birth: "",
    email: "",
    guardian_first_name: '',
    guardian_last_name: '',
    guardian_relation: '',
    mobileCode: {
      label: '+91 - India',
      value: 'IN',
      currLabel: '+91',
    },
    country: 'India',
  },
  errors: {
    first_name: "",
    last_name: "",
    mobile: "",
    date_of_birth: "",
    email: "",
    guardian_first_name: '',
    guardian_last_name: '',
    guardian_relation: '',
    country: ''
  },
};
 const emailRequired = 'Email field is required'
 const first_name = 'First Name field is required'
 const last_name = 'Last Name field is required'
 const emailInvalid = 'Email field is invalid'
 const lastNameRequired = 'Last Name field is required'
 const nameMax = 'Name cannot be more than 100 characters long.'
 const fnameMax = 'First Name cannot be more than 50 characters long.'
 const lnameMax = 'Last Name cannot be more than 50 characters long.'
 const mobileCodeRequired = 'Mobile Code field is required'

class EditPatient extends Form {
  state = initialState;
  schema = {
    first_name: Joi.string()
      .required()
      .label("First Name")
      .error(() => {
        return { message: first_name };
      }),
    last_name: Joi.string()
      .required()
      .label("Last Name")
      .error(() => {
        return { message: last_name };
      }),    
    mobileCode: Joi.object()
      .required()
      .error(() => {
        return { message: mobileCodeRequired }
      }),
    country: Joi.string(),
    mobile: Joi.number()
      .label("Mobile number")
      .min(10000000)
      .max(999999999999999)
      .error((errors) => {
        console.log(errors);
        errors.forEach((err) => {
          switch (err.type) {
            case "number.base":
			err.message = mobileRequired;
              break;

            case "number.max":
              err.message = mobileInvalid;
              break;

            case "number.min":
              err.message = mobileInvalid;
              break;
          }
        });
        return errors;
      }),
    date_of_birth: Joi.date()
      .max(Joi.ref('$maxDob'))
      .label("Date of birth")
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "date.base":
              err.message = dobRequired;
              break;

            case "date.max":
              err.message = dobInvalid;
              break;
          }
        });
        return errors;
      }),
      email: Joi.string()
      .email()
      .max(50)
      .required()
      .label('Email')
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'any.empty':
              err.message = emailRequired
              break

            case 'string.email':
              err.message = emailInvalid
              break
            case 'string.max':
              err.message = emailInvalid
              break
          }
        })
        return errors
      }),
      guardian_first_name: Joi.string()
      .allow('')
      .max(50)
      .label('Last Name')
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'any.empty':
              err.message = lastNameRequired
              break

            case 'string.max':
              err.message = fnameMax
              break
          }
        })
        return errors
      }),

    guardian_last_name: Joi.string()
      .allow('')
      .max(50)
      .label('Last Name')
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'any.empty':
              err.message = lastNameRequired
              break

            case 'string.max':
              err.message = lnameMax
              break
          }
        })
        return errors
      }),
    guardian_relation: Joi.string()
      .allow('')
      .max(50)
      .label('Last Name')
      .error(errors => {
        errors.forEach(err => {
          switch (err.type) {
            case 'any.empty':
              err.message = lastNameRequired
              break

            case 'string.max':
              err.message = lnameMax
              break
          }
        })
        return errors
      }),    
  };
  // doSubmit = () => {
  //     const { data } = this.state;
  //     const id = this.props.id;
  //     const updatedData = { ...data, email: data.email.toLowerCase(), mobileCode: data.mobileCode.currLabel };
  //     console.log("doSubmit data : ", updatedData)

  //     this.props.updatePatient(id, updatedData, this.callback);
  //   // const payLoad = {
  //   //   mobile: this.state.data.mobile,
  //   //   type: this.props.data?.type === 1 ? '1' : '2',
  //   // }
  //   // this.props.mobileAvailability(payLoad, this.callBaclMobile)

  // };

  // // callBaclMobile = res => {
  // //   if (res.status === 200) {
  // //     const payLoad = {
  // //       email: this.state.data.email.toLowerCase(),
  // //       type: this.props.data?.type === 1 ? '1' : '2',
  // //     }
  // //     this.props.emailAvailability(payLoad, this.callBaclEmail)
  // //   } else {
  // //     console.log("error ------> ", res)
  // //     toast(<AlertError message={res.data.error}/>)
  // //   }
  // // }

  // // callBaclEmail = res => {
  // //   if (res.status === 200) {
  // //     const { data } = this.state;
  // //     const id = this.props.id;
  // //     const updatedData = { ...data, email: data.email.toLowerCase(), mobileCode: data.mobileCode.currLabel };
  // //     console.log("doSubmit data : ", updatedData)

  // //     this.props.updatePatient(id, updatedData, this.callback);
  // //   } else {
  // //     toast(<AlertError message={res.data.error} />)
  // //   }
  // // }

    doSubmit = () => {
    const { data } = this.state;
    const id = this.props.id;

    const updatedData = {
      ...data,
      email: data.email.toLowerCase(),
      mobileCode: data.mobileCode.currLabel,
    };

    const originalData = this.props.data;
    const mobileChanged = data.mobile !== originalData.mobile ;
    const emailChanged = data.email.toLowerCase() !== originalData.email ;
    if (mobileChanged) {
      const mobilePayload = {
        mobile: data.mobile,
        type: originalData?.type === 1 ? '1' : '2',
      };
      this.props.mobileAvailability(mobilePayload, this.callBaclMobile);
    } else if (emailChanged) {
      const emailPayload = {
        email: data.email.toLowerCase(),
        type: originalData?.type === 1 ? '1' : '2',
      };
      this.props.emailAvailability(emailPayload, this.callBaclEmail);
    } else {
      this.props.updatePatient(id, updatedData, this.callback);
    }
  };

  callBaclMobile = (res) => {
    if (res.status === 200) {
      const emailChanged =
        this.state.data.email.toLowerCase() !==
        this.props.data.email ;

      if (emailChanged) {
        const emailPayload = {
          email: this.state.data.email.toLowerCase(),
          type: this.props.data?.type === 1 ? '1' : '2',
        };
        this.props.emailAvailability(emailPayload, this.callBaclEmail);
      } else {
        this.finalUpdate();
      }
    } else {
      toast(<AlertError message={res.data.error} />);
    }
  };

  callBaclEmail = (res) => {
    if (res.status === 200) {
      this.finalUpdate();
    } else {
      toast(<AlertError message={res.data.error} />);
    }
  };

  finalUpdate = () => {
    const { data } = this.state;
    const id = this.props.id;

    const updatedData = {
      ...data,
      email: data.email.toLowerCase(),
      mobileCode: data.mobileCode.currLabel,
    };

    this.props.updatePatient(id, updatedData, this.callback);
  };

	callback = (res) => {
      if (res && res.status === 200) {
        this.props.loadAllPatient({"page":this.props.initialPage});
        this.props.toggleEditUser();
        toast(<AlertSuccess message={informationSaved}/>)
      } 
      else{
        toast(<AlertError message={failed}/>)
      }
    };
  
    onChange = e => {
      const { data, errors } = this.state
      // console.log("onchange1 : ",e.target.name)
      // console.log("onchange2 : ",e.target.value)
      data[e.target.name] = e.target.value;
      this.setState({ data });
    }
    
    toogleClose = () => {
      this.setState(initialState);
      this.props.toggleEditUser();
    }
    componentDidMount = () => {
      this.setState({
        data: {
          first_name: this.props.data.first_name,
          last_name: this.props.data.last_name,
          mobile: this.props.data.mobile,
          date_of_birth: this.props.data.date_of_birth ? new Date(this.props.data.date_of_birth) : null, 
          email: this.props.data.email,
          guardian_first_name: this.props.data.guardian_first_name,
          guardian_last_name: this.props.data.guardian_last_name,
          guardian_relation: this.props.data.guardian_relation,
          mobileCode: this.props.data.mobileCode,
          country: this.props.data.country,

        },
      });
	};
	
  componentDidUpdate(prevProps) {
    // console.log("this.props.data : ",this.props.data)
    if (prevProps.id !== this.props.id && this.props.data) {
      this.setState({
        data: {
          first_name: this.props.data.first_name || "",
          last_name: this.props.data.last_name || "",
          mobile: this.props.data.mobile || "",
          date_of_birth: this.props.data.date_of_birth
            ? new Date(this.props.data.date_of_birth)
            : null,
          email: this.props.data.email || "",
          guardian_first_name: this.props.data.guardian_first_name || "",
          guardian_last_name: this.props.data.guardian_last_name || "",
          guardian_relation: this.props.data.guardian_relation || "",
          country: this.props.data.country || "India",
          mobileCode: Country.getAllCountries()
            .map((ele) => ({
              label:
                (ele.phonecode.startsWith("+")
                  ? ele.phonecode
                  : "+" + ele.phonecode) + " - " + ele.name,
              value: ele.isoCode,
              currLabel: ele.phonecode.startsWith("+")
                ? ele.phonecode
                : "+" + ele.phonecode,
            }))
            .find(
              (option) =>
                option.currLabel === this.props.data.mobileCode
            ) || {
            label: "+91 - India",
            value: "IN",
            currLabel: "+91",
          },
        },
      });
    }
  }
	

  render() {
    return (
      <>
        <div
          className={
            this.props.isShow === true
              ? "offcanvas offcanvas-left p-10 offcanvas-on"
              : "offcanvas offcanvas-left p-10"
          }
        >
          <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
            <h3 className="font-weight-bold m-0">Edit Patient Detail</h3>
            <a
              href="javascript:void (0)"
              className="btn btn-xs btn-icon btn-light btn-hover-primary"
              onClick={this.toogleClose}
            >
              <i className="ki ki-close icon-xs text-muted"></i>
            </a>
          </div>
          <hr/>
          <form action="" onSubmit={this.handleSubmit}>
            {this.props.data?.type === 2 && (
                        <Select2
                          name='guardian_relation'
                          options={[
                            { value: 'Father', name: 'Father' },
                            { value: 'Mother', name: 'Mother' },
                            { value: 'Grand Father', name: 'Grand Father' },
                            { value: 'Grand Mother', name: 'Grand Mother' },
                            { value: 'Brother', name: 'Brother' },
                            { value: 'Sister', name: 'Sister' },
                            { value: 'Husband', name: 'Husband' },
                            { value: 'Wife', name: 'Wife' },
                            { value: 'Friend', name: 'Friend' },
                            { value: 'Son', name: 'Son' },
                            { value: 'Daughter', name: 'Daughter' },
                            { value: 'Grandchild', name: 'Grandchild' },
                            { value: 'Others', name: 'Others' },
                          ]}
                          label='Relation'
                          error={this.state.errors.guardian_relation}
                          value={this.state.data.guardian_relation}
                          onChange={this.onChange}
                        />
                    )}
           <div className='row'>
           <div className='col-md-6'>          
            {this.renderInput("first_name", "First Name")}
            </div>
            <div className='col-md-6'> 
            {this.renderInput("last_name", "Last Name")}
            </div>
            </div>
            {this.renderDateInput("date_of_birth", "DOB")}
            {this.props.data?.type === 2 && (
                  <div className='row'>
                    <div className='col-md-6'>
                      {this.renderInput(
                        'guardian_first_name',
                        'Guardian First Name'
                      )}
                    </div>
                    <div className='col-md-6'>
                      {this.renderInput(
                        'guardian_last_name',
                        'Guardian Last Name'
                      )}
                    </div>
                  </div>
                )}
                <div className='row'>
                <div className='col-md-6'>
                  <label htmlFor="countryCodeSelect" style={{ display: 'block', marginBottom: 4 }}>
                  Select Country Code
                  </label>
                    <Select
                      inputId="countryCodeSelect" 
                      styles={this.customStyles}
                      onChange={e => {
                        console.log('e se', e)
                        const data = { ...this.state.data }
                        data.mobileCode = {
                          label: e.label,
                          value: e.value,
                          currLabel: e.currLabel,
                        }
                        data.country = e.name

                        this.setState({ data })
                      }}
                      placeholder='Select Country Code'
                      value={this.state.data.mobileCode}
                      defaultValue={this.state.data.mobileCode}
                      getOptionLabel={x => x.label}
                      getOptionValue={x => x.value}
                      options={Country.getAllCountries().map(ele => ({
                        label:
                          (ele.phonecode.startsWith('+')
                            ? ele.phonecode
                            : '+' + ele.phonecode) +
                          ' - ' +
                          ele.name,
                        value: ele.isoCode,
                        name: ele.name,
                        currLabel: ele.phonecode.startsWith('+')
                          ? ele.phonecode
                          : '+' + ele.phonecode,
                      }))}
                    />
            </div>
            <div className='col-md-6'>
            {this.renderInput('mobile', 'Mobile Number', 'text')}
            </div>
            </div>
            {this.renderInput('email', 'Email')}

            <hr />
            <div className="form-group d-flex flex-wrap justify-content-between align-items-center mt-2">
              <div className="my-3 mr-2">
                <span className="text-muted mr-2"></span>
                <a href="#" className="font-weight-bold"></a>
              </div>
              <button type="submit" className="btn btn-primary font-weight-bolder" >
                Save
              </button>
            </div>
          </form>
        </div>
        {this.props.isShow === true ? (
          <div className="offcanvas-overlay"></div>
        ) : (
          ""
        )}
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  patient: getProduct(state).patient,
});
const mapDispatchToProps = (dispatch) => ({
  loadAllPatient: (params) => dispatch(loadAllPatient(params)),
  updatePatient: (id, data, callback) =>
    dispatch(updatePatient(id, data, callback)),
  mobileAvailability: (param, callback) =>
    dispatch(mobileAvailability(param, callback)),
  emailAvailability: (param, callback) =>
    dispatch(emailAvailability(param, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EditPatient);
